import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const TOAST_STATE = {
  success: 'success-toast',
  warning: 'warning-toast',
  danger: 'danger-toast'
};

@Injectable({
  providedIn: 'root'
})

export class ToastService {

  public showToast$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public toastMessage$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public toastTitle$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public toastState$: BehaviorSubject<string> = new BehaviorSubject<string>(TOAST_STATE.success);
  
  constructor() { }
  
  showToast(toastState: string, toastTitle: string, toastMsg: string): void {
    this.toastState$.next(toastState);
    this.toastMessage$.next(toastMsg);
    this.toastTitle$.next(toastTitle);
    this.showToast$.next(true); 
    setTimeout(() => {
      this.dismissToast();
    }, 3500);
  }  
   
  dismissToast(): void {    
    this.showToast$.next(false);  
  }
}
